// Web admin dibuka di dalam aplikasi Flutter (admin cabang / superadmin). Aplikasi membuka halaman dengan
// ?app=1 dan memakai sidebar-nya sendiri, jadi sidebar & navbar web disembunyikan. Tanda disimpan di
// sessionStorage supaya tetap berlaku saat berpindah halaman di dalam web.
const KUNCI = 'tampilan_aplikasi';

export const tandaiModeAplikasi = () => {
  try {
    if (new URLSearchParams(window.location.search).get('app') === '1') sessionStorage.setItem(KUNCI, '1');
  } catch (_) {
    // sessionStorage tidak tersedia
  }
};

export const modeAplikasi = () => {
  try {
    return sessionStorage.getItem(KUNCI) === '1';
  } catch (_) {
    return false;
  }
};
